// extracted by css-extract-rspack-plugin
export default {"pageLayout":"src-app-pages-electronic-preparation-Contract-Contract-module__pageLayout-U82ruA","titleBox":"src-app-pages-electronic-preparation-Contract-Contract-module__titleBox-JlJ5vc","bodyTable":"src-app-pages-electronic-preparation-Contract-Contract-module__bodyTable-z_X4YL"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"pageLayout\":\"src-app-pages-electronic-preparation-Contract-Contract-module__pageLayout-U82ruA\",\"titleBox\":\"src-app-pages-electronic-preparation-Contract-Contract-module__titleBox-JlJ5vc\",\"bodyTable\":\"src-app-pages-electronic-preparation-Contract-Contract-module__bodyTable-z_X4YL\"}";
        // 1789362522831
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  